// 轻量电话工具（无第三方依赖）
// 注意：仅做基础校验，后端仍会最终校验/兜底

export function parseCountry(code) {
  const s = (code || '').toString();
  const parts = s.split(':');
  const iso2 = (parts[0] || '').toUpperCase();
  const dial = parts[1] || '';
  return { iso2, dial };
}

export function normalizePhone(num) {
  if (!num) return '';
  return num.replace(/[^\d]/g, '');
}

export function isValidPhone(num, iso2) {
  const n = normalizePhone(num);
  const digits = n.length;
  const cc = (iso2 || '').toUpperCase();
  if (cc === 'US') {
    // 美国：10位纯数字
    return /^\d{10}$/.test(n);
  }
  if (cc === 'CN') {
    // 中国：11位，1开头
    return /^1\d{10}$/.test(n);
  }
  if (cc === 'GB') {
    // 英国：10-11位数字（简化）
    return /^\d{10,11}$/.test(n);
  }
  // 其他国家：4-15位数字（保守）
  return /^\d{4,15}$/.test(n);
}

